import type {
	BannerSettings,
	UserSettingsMap,
	AssetsLogoResponse,
	AssetsFaviconResponse,
} from './types.tsx';

export const RESOURCE_ASSETS_NAVIGATION_SETTINGS = 'RESOURCE_ASSETS_NAVIGATION_SETTINGS';
export const RESOURCE_ASSETS_NAVIGATION_SETTINGS_KEY = 'assets-navigation-settings';

export const RESOURCE_ASSETS_BANNER_SETTINGS = 'RESOURCE_ASSETS_BANNER_SETTINGS';
export const RESOURCE_ASSETS_BANNER_SETTINGS_KEY = 'assets-banner-settings';

export const RESOURCE_ASSETS_USER_SETTINGS = 'RESOURCE_ASSETS_USER_SETTINGS';
export const RESOURCE_ASSETS_USER_SETTINGS_KEY = 'assets-user-settings';

export const USER_SETTING_BANNER_DISMISSAL_KEY = 'shouldShowBanner';

export const DEFAULT_HIGHLIGHT_COLOR = '#0052CC';
export const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';

export const NAVIGATION_SETTINGS_KEYS = {
	BG_COLOR: 'assets.navigation.bgcolour',
	HIGHLIGHT_COLOR: 'assets.navigation.highlightcolour',
} as const;

export const DATE_TIME_SETTINGS_KEYS = {
	TIMEZONE: 'assets.timezone',
} as const;

export const RESOURCE_TYPE_WORKSPACE_CONTEXT = 'JSM_INSIGHT_WORKSPACE_CONTEXT';

// Cache duration for assets admin settings (15 minutes)
export const ASSETS_ADMIN_SETTINGS_MAX_AGE: number = 15 * 60 * 1000;

export const emptyNavigationSettingsResponse = {
	backgroundColor: '',
	highlightColor: '',
	timezone: '',
};

export const emptyBannerSettingsResponse: BannerSettings = {
	id: '',
	content: {
		version: 1,
		type: 'doc',
		content: [],
	},
	isDismissable: false,
	isEnabled: false,
	hashId: '',
	visibility: '',
	bgColor: '',
};

export const emptyUserSettingsResponse: UserSettingsMap = {};

export const RESOURCE_ASSETS_LOGO_FAVICON = 'RESOURCE_ASSETS_LOGO_FAVICON';
export const RESOURCE_ASSETS_LOGO_FAVICON_KEY = 'assets-logo-favicon';

export const emptyLogoResponse: AssetsLogoResponse = {
	workspaceId: '',
	logoUUID: '',
	logoFileName: '',
	isDefaultLogo: true,
	url16: '',
	url48: '',
	url72: '',
	url144: '',
	url288: '',
};

export const emptyFaviconResponse: AssetsFaviconResponse = {
	workspaceId: '',
	faviconUUID: '',
	faviconFileName: '',
	isDefaultFavicon: true,
	url16: '',
	url32: '',
	url48: '',
	url64: '',
};

export const TEAM_NAME = 'aurum';
export const PACKAGE_NAME = 'jiraRouterResourcesAssetsAdminSettings';
